import { useGlobalStore } from '@/stores/global';

export default defineNuxtPlugin((nuxtApp) => {
  const globalStore = useGlobalStore();

  // перед початком переходу (пропускаємо початкову гідратацію: контент вже
  // відрендерений на сервері, і показ прелоадера поверх нього дав би зайве
  // миготіння)
  nuxtApp.hook('page:start', () => {
    if (nuxtApp.isHydrating) return;
    globalStore.startLoader();
  });

  // коли сторінка (включно з asyncData / useAsyncData) вже готова
  nuxtApp.hook('page:finish', () => {
    if (nuxtApp.isHydrating) return;
    // невеликий таймаут, щоб уникнути миготіння
    setTimeout(() => {
      globalStore.stopLoader();
    }, 100);
  });

  // на випадок помилок навігації — скидати лоадер
  nuxtApp.hook('app:error', () => {
    globalStore.resetLoader();
  });
});
